import React from "react";

const Multilevel_Inheritance = () => {
  return (
    <div>
      <h1>Multilevel_Inheritance Component</h1>
      <p>Content for Multilevel_Inheritance goes here...</p>
    </div>
  );
};

export default Multilevel_Inheritance;
